// Copyright © 2019-2026 Focal Systems. All rights reserved.

export function AnswerNote({ text }: { text: string }) {
  return <div className="mb-2 rounded-lg border border-dashed px-3 py-2 text-muted-foreground text-sm">{text}</div>;
}
